export default __webpack_public_path__ + "static/media/css3.de88f6dc.png";